import React, { useState, useEffect,useContext } from "react";
import Swal from "sweetalert2";
import axios from 'axios';
import { AppContext } from "../../../services/AppContext";
import AuthContext from '../../../context/auth-context';
import { MdEdit, MdErrorOutline, MdSave, MdCheck } from "react-icons/md";
import useFileInput from '../../../hooks/useFileInput';
import Card from '../../../components/UI/Card';
import useGetAdjuntosdocs from '../../../hooks/useGetAdjuntosdocs';
import DownloadA from "../../DownloadA";


const AdjuntosDocumentos = (props) => {
    const { setAppValues } = useContext(AppContext);
    const authContext = useContext(AuthContext);

    const [error, setError] = useState(false);
    
    const [block, setBlock] = useState(false);
    const handleEditar = () => {
        setBlock(!block);
    }
    
    const [isUpdate, setIsUpdate] = useState(false);
    
    const adjuntos = useGetAdjuntosdocs(authContext.token);
    
    useEffect(() => {
        if(adjuntos.LOADING){
            Swal.fire({
                title: `Loading...
                    <div class="spinner-border text-primary mt-4" role="status" />
                `,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            return;
        }
        Swal.close();

        if(adjuntos.STATUS && adjuntos.STATUS === "SUCCESS"){
            setError(false);

        } else if(adjuntos.STATUS && adjuntos.STATUS === "ERROR"){
            setError(true);

            Swal.fire({
                icon: 'error',
                title: "¡Error!",
                text: adjuntos.ERROR.MESSAGE,
                showConfirmButton: false,
                showDenyButton: true,
                denyButtonText: "Aceptar",
                backdrop: true,
                allowOutsideClick: false
            });

        } else {
            setError(true);
            
            Swal.fire({
                icon: 'error',
                title: "¡Error!",
                text: 'Ocurrió un problema, intentelo más tarde',
                showConfirmButton: false,
            });
        }
    }, [adjuntos]);

  //INPUT ARCHIVO DE IDENTIFICACION PERSONAL
  const [nombreIdentificacionFile, setNombreIdentificacionFile] = useState("");
  const {
      value: identificacionFile,
      fileName: identificacionFileName,
      isValid: identificacionFileIsValid,
     // isTouched: identificacionFileIsTouched,
      divInput: divIdentificacionFile,
     // messageFile: messageIdentificacion,
      valueChangeHandler: identificacionFileChangeHanlder,
      inputBlurHandler: identificacionFileBlurHandler,
     // scrollToDiv: scrollToDivIdentificacionFile
  } = useFileInput(nombreIdentificacionFile, "application/pdf,image/jpeg");

  useEffect(() => {
      setNombreIdentificacionFile(!!adjuntos.identificacion ? adjuntos.identificacion : nombreIdentificacionFile);
  }, [adjuntos.identificacion, nombreIdentificacionFile, setNombreIdentificacionFile]);

    //INPUT CURRICULUM (ARCHIVO)
    const [nombreCVFile, setNombreCVFile] = useState("");
    const {
        value: curriculumFile,
        fileName: curriculumFileName,
        isValid: curriculumFileIsValid,
      //  isTouched: curriculumFileIsTouched,
        divInput: divCurriculum,
       // messageFile: messageCurriculum,
        valueChangeHandler: curriculumFileChangeHanlder,
        inputBlurHandler: curriculumFileBlurHandler,
      //  scrollToDiv: scrollToDivCurriculum
    } = useFileInput(nombreCVFile, "application/pdf");

    useEffect(() => {
        setNombreCVFile(!!adjuntos.curriculum ? adjuntos.curriculum : nombreCVFile);
    }, [adjuntos.curriculum, nombreCVFile, setNombreCVFile]);

    //INPUT CARTA DE RECOMENDACION (ARCHIVO)
    const [nombreRecomendacionFile, setRecomendacionFile] = useState("");
    const {
        value: recomendacionFile,
        fileName: recomendacionFileName,
        isValid: recomendacionFileIsValid,
       // isTouched: recomendacionFileIsTouched,
        divInput: divRecomendacion,
      //  messageFile: messageRecomendacion,
        valueChangeHandler: recomendacionFileChangeHanlder,
        inputBlurHandler: recomendacionFileBlurHandler,
      //  scrollToDiv: scrollToDivRecomendacion
    } = useFileInput(nombreRecomendacionFile, "application/pdf");

    useEffect(() => {
        setRecomendacionFile(!!adjuntos.recomendacion ? adjuntos.recomendacion : nombreRecomendacionFile);
    }, [adjuntos.recomendacion, nombreRecomendacionFile, setRecomendacionFile]);

    //INPUT MOTIVACION (ARCHIVO)
    const [nombreMotivacionFile, setMotivacionFile] = useState("");
    const {
        value: motivacionFile,
        fileName: motivacionFileName,
        isValid: motivacionFileIsValid,
       // isTouched: motivacionFileIsTouched,
        divInput: divMotivacion,
       // messageFile: messageMotivacion,
        valueChangeHandler: motivacionFileChangeHanlder,
        inputBlurHandler: motivacionFileBlurHandler,
        //scrollToDiv: scrollToDivMotivacion
    } = useFileInput(nombreMotivacionFile, "application/pdf");

    useEffect(() => {
        setMotivacionFile(!!adjuntos.recomendacion2 ? adjuntos.recomendacion2 : nombreMotivacionFile);
    }, [adjuntos.recomendacion2, nombreMotivacionFile, setMotivacionFile]);


      //INPUT TITULO (ARCHIVO)
    const [nombreTituloFile, setTituloFile] = useState("");
    const {
        value: tituloFile,
        fileName: tituloFileName,
        isValid: tituloFileIsValid,
       // isTouched: tituloFileIsTouched,
        divInput: divTitulo,
      //  messageFile: messageTitulo,
        valueChangeHandler: tituloFileChangeHanlder,
        inputBlurHandler: tituloFileBlurHandler,
      //  scrollToDiv: scrollToDivTitulo
    } = useFileInput(nombreTituloFile, "application/pdf");

    useEffect(() => {
        setTituloFile(!!adjuntos.titulo ? adjuntos.titulo : nombreTituloFile);
    }, [adjuntos.titulo, nombreTituloFile, setTituloFile]);


    // INPUT HISTORIAL DE NOTAS
    const [nombreHistorialNotasFile, setHistorialNotasFile] = useState("");
    const {
        value: HistorialNotasFile,
        fileName: HistorialNotasFileName,
        isValid: HistorialNotasFileIsValid,
      //  isTouched: HistorialNotasFileIsTouched,
        divInput: divHistorialNotas,
      //  messageFile: messageHistorialNotas,
        valueChangeHandler: HistorialNotasFileChangeHanlder,
        inputBlurHandler: HistorialNotasFileBlurHandler
      //  scrollToDiv: scrollToDivHistorialNotas
    } = useFileInput(nombreHistorialNotasFile, "application/pdf");

    // historialnotas

    useEffect(() => {
        setHistorialNotasFile(!!adjuntos.historialnotas ? adjuntos.historialnotas : nombreHistorialNotasFile);
    }, [adjuntos.historialnotas, nombreHistorialNotasFile, setHistorialNotasFile]);

    

    //TODO: Agregar aquí, la comprobación de los 5 adjuntos, notar que deberian ser 2 , una para setBlock, setIsUpdate
    useEffect(() => {
       
        let flag = !!adjuntos.identificacion && adjuntos.identificacion !== ""
        //let flagBlock = !!adjuntos.identificacion && adjuntos.identificacion !== ""
        let flagUpdateBotonEditar= (!!adjuntos.identificacion && adjuntos.identificacion !== "")  || (!!adjuntos.recomendacion && adjuntos.recomendacion !== "")   || (!!adjuntos.recomendacion2 && adjuntos.recomendacion2 !== "") || (!!adjuntos.titulo && adjuntos.titulo !== "") || (!!adjuntos.historialnotas && adjuntos.historialnotas !== "")
        

        //setBlock(true); //esto permite habilitar el boton editar, deberia mostrarse si al menos uno de los adjuntos ya fue registrado

        
      
        if (flagUpdateBotonEditar){
        
            setBlock(true);
            setIsUpdate(true);

        } 


        /*if(flag){
            setBlock(true);
            setIsUpdate(true);
        }*/
    }, [adjuntos]);


  

    
    let formIsValid = false;

    //Para que el form sea enviada por lo menos debe ser válido uno de los inputs.

    if (
        identificacionFileIsValid ||
        curriculumFileIsValid ||
        recomendacionFileIsValid ||
        motivacionFileIsValid ||
        tituloFileIsValid ||
        HistorialNotasFileIsValid
    ){
        formIsValid = true;
    }

    const handleSubmit = async (ev) => {
        ev.preventDefault();

       // identificacionFileBlurHandler();
       // curriculumFileBlurHandler();
       // recomendacionFileBlurHandler();
       // motivacionFileBlurHandler();
       // tituloFileBlurHandler();
  
        if(!formIsValid) {

            return;

           /* if(!identificacionFileIsValid){
                scrollToDivIdentificacionFile();
                return;
            }

            if(!curriculumFileIsValid){
                scrollToDivCurriculum();
                return;
            }

            if(!recomendacionFileIsValid){
                scrollToDivRecomendacion();
                return;
            }

            if(!motivacionFileIsValid){
                scrollToDivMotivacion();
                return;
            }*/

          /*  if(!tituloFileIsValid){
                scrollToDivTitulo();
                return;
            }*/

        }

        

        const form_data = new FormData();
        form_data.append('idToken', authContext.token);
        form_data.append('identificacionFile', identificacionFile[0] === undefined ? nombreIdentificacionFile : identificacionFile[0]);
        form_data.append('curriculum', curriculumFile[0] === undefined ? nombreCVFile : curriculumFile[0]);
        form_data.append('recomendacion', recomendacionFile[0] === undefined ? nombreRecomendacionFile : recomendacionFile[0]);
        form_data.append('recomendacion2', motivacionFile[0] === undefined ? nombreMotivacionFile : motivacionFile[0]);
        form_data.append('titulo', tituloFile[0] === undefined ? nombreTituloFile : tituloFile[0]);
        form_data.append('historialnotas', HistorialNotasFile[0] === undefined ? nombreHistorialNotasFile : HistorialNotasFile[0]);

        //nombreHistorialNotasFile



        if(isUpdate)
        {
            form_data.append('updateAdjuntos', 1);
        } else {
            form_data.append('saveAdjuntos', 1);
        }
        axios.post(process.env.REACT_APP_API_URL, form_data)
        .then(res => {

                 //console.log(res.data);

                // Indicará 1 si todos los documentos estan completos
                 var documentos_todos =res.data.DOCUMENTOS_COMPLETO;

                 if (documentos_todos > 0){
                    
                    setAppValues(
                        prev => {
                            let perfil = prev.documentosAdjuntos ? prev.perfil : prev.perfil+20;
                            return { ...prev, documentosAdjuntos: true, perfil };
                        }
                    );

                 }



                /*setAppValues(
                    prev => {
                        let perfil = prev.documentosAdjuntos ? prev.perfil : prev.perfil+20;
                        return { ...prev, documentosAdjuntos: true, perfil };
                    }
                );*/
                setIsUpdate(true);
                handleEditar();

                if (documentos_todos > 0){
                props.onCompletado('adjuntos-docs');
                }


                //TODO: este props (talvez) y el setAppValues solo debe realizarse al momento de comprobar los valores 
            })
            .catch((error) => {
                console.log(error);
                Swal.fire({
                    icon: 'error',
                    title: 'Ocurrió un problema, intentelo más tarde',
                    showConfirmButton: false,
                    timer: 3500
                });

            })
    }

    return (
        <>
        {
            error && 
            <div className="row">
                <div className="col-lg-12 mb-5">
                    <Card>
                        <div className="card-body d-flex align-items-center justify-content-center" style={{ height: '565px' }}>
                            <div className="text-center" style={{ color: 'rgba(0,0,0,.3)', fontSize: '2.5rem' }} >
                                <span style={{ fontSize: "7rem" }}><MdErrorOutline/></span>
                                <br />
                                ¡Error!
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        }
        { !error && 
            <div className="row">
                <div className="col-lg-12 mb-5">
                    <Card>
                        <div className="card-body">
                            <form className="row my-4" onSubmit={ev => handleSubmit(ev)}>



                                {/* DOCUMENTO DE IDENTIFICACION */}
                         <div className="col-md-10 offset-md-1 mb-3" ref={divIdentificacionFile}>                                    
                                <label className="form-label text-black-50" style={{userSelect: "none"}}>Adjuntar documento de identificación (PDF)</label>

                                    <input
                                        type="file"
                                        name="identificacionFile"
                                        className={`form-control form-control-sm shadow-sm`}
                                        onChange={identificacionFileChangeHanlder}
                                        onBlur={identificacionFileBlurHandler} 
                                        disabled={block ? true : false} />
                                
                                    {identificacionFileIsValid && <div id="identificacionFileHelp" className="form-text fst-italic" style={{userSelect: "none"}}>
                                        <span className="text-success"><MdCheck /></span> {identificacionFileName}
                                    </div>}
                                </div>

                                <hr className="col-md-10 offset-md-1 my-2 text-black-50 shadow" />

                                {/* ARCHIVO CV */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divCurriculum}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Adjuntar curriculum vitae (PDF)</label>
                                    <input
                                        type="file"
                                        name="curriculum"
                                        className={`form-control form-control-sm shadow-sm`}
                                        onChange={curriculumFileChangeHanlder}
                                        onBlur={curriculumFileBlurHandler} 
                                        disabled={block ? true : false} />
                                
                                    {curriculumFileIsValid && <div id="curriculumHelp" className="form-text fst-italic" style={{userSelect: "none"}}>
                                        <span className="text-success"><MdCheck /></span> {curriculumFileName}
                                    </div>}
                                </div>

                                <hr className="col-md-10 offset-md-1 my-2 text-black-50 shadow" />


                                {/* ARCHIVO RECOMENDACION */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divRecomendacion}>
                                    <label className="form-label text-black-50">Adjuntar 2 cartas de recomendación (utilizar el formato oficial, subir en PDF). Descargar el formato oficinal aquí:</label>
                                   
                                    <ul>
                                    <li>
                                    <DownloadA url="https://en.ufm.edu/wp-content/uploads/2022/06/EN-carta-de-recomendacion-ESP.docx" nombre="Carta de recomendación (español)"/>
                                    </li>
                                    
                                    <li>
                                    <DownloadA url="https://en.ufm.edu/wp-content/uploads/2022/06/EN-letter-of-recommendation-ENG.docx" nombre="Carta de recomendación (inglés)"/>
                                    </li>
                            
                                    </ul>
                                    
                                    <input
                                        type="file"
                                        name="recomendacion"
                                        className={`form-control form-control-sm shadow-sm`}
                                        onChange={recomendacionFileChangeHanlder}
                                        onBlur={recomendacionFileBlurHandler} 
                                        disabled={block ? true : false} />
                                    {recomendacionFileIsValid && <div id="recomendacionHelp" className="form-text fst-italic" style={{userSelect: "none"}}>
                                        <span className="text-success"><MdCheck /></span> {recomendacionFileName}
                                    </div>}
                                </div>

                                {/* ARCHIVO MOTIVACION */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divMotivacion}>
                                    <input
                                        type="file"
                                        name="motivacion"
                                        className={`form-control form-control-sm shadow-sm`}
                                        onChange={motivacionFileChangeHanlder}
                                        onBlur={motivacionFileBlurHandler} 
                                        disabled={block ? true : false}
                                    />
                                    {motivacionFileIsValid && <div id="motivacionHelp" className="form-text fst-italic" style={{userSelect: "none"}}>
                                        <span className="text-success"><MdCheck /></span> {motivacionFileName}
                                    </div>}
                                </div>

                                <hr className="col-md-10 offset-md-1 my-2 text-black-50 shadow" />


                                
                                {/* TITULO */}
                         <div className="col-md-10 offset-md-1 mb-3" ref={divTitulo}>                                    
                                <label className="form-label text-black-50" style={{userSelect: "none"}}>Adjuntar Título (PDF - Ambos lados)</label>

                                    <input
                                        type="file"
                                        name="tituloFile"
                                        className={`form-control form-control-sm shadow-sm`}
                                        onChange={tituloFileChangeHanlder}
                                        onBlur={tituloFileBlurHandler} 
                                        disabled={block ? true : false} />
                                 
                                    {tituloFileIsValid && <div id="tituloFileHelp" className="form-text fst-italic" style={{userSelect: "none"}}>
                                        <span className="text-success"><MdCheck /></span> {tituloFileName}
                                    </div>}
                                </div>

                                <hr className="col-md-10 offset-md-1 my-2 text-black-50 shadow" />



                                         {/* HistorialNotas */}
                         <div className="col-md-10 offset-md-1 mb-3" ref={divHistorialNotas}>                                    
                                <label className="form-label text-black-50" style={{userSelect: "none"}}>Historial de notas del último grado académico obtenido (PDF)</label>

                                    <input
                                        type="file"
                                        name="HistorialNotasFile"
                                        className={`form-control form-control-sm shadow-sm`}
                                        onChange={HistorialNotasFileChangeHanlder}
                                        onBlur={HistorialNotasFileBlurHandler} 
                                        disabled={block ? true : false} />
                                  
                                    {HistorialNotasFileIsValid && <div id="HistorialNotasFileHelp" className="form-text fst-italic" style={{userSelect: "none"}}>
                                        <span className="text-success"><MdCheck /></span> {HistorialNotasFileName}
                                    </div>}
                                </div>


                                
                                {/* EDITAR/GUARDAR */}
                                <div className="col-md-10 offset-md-1 mt-3" style={{ textAlign: 'right' }}>
                                    <div className="btn-group">
                                        <button 
                                            className={`btn ${block ? 'btn-dark':'btn-outline-dark disabled'}`}
                                            type="button"
                                            onClick={() => handleEditar()}
                                            disabled={!block} >
                                            <MdEdit /> Editar
                                        </button>
                                        <button 
                                            className={`btn ${block ? 'btn-outline-danger disabled':'btn-danger'}`}
                                            disabled={block} 
                                            type="submit">
                                            <MdSave /> Guardar
                                        </button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </ Card>
                </div>
            </div>
        }
        </>
    );
};

export default AdjuntosDocumentos;